document.addEventListener('DOMContentLoaded', () => {
  const heatpoints = document.querySelectorAll('.shoe-breakdown__heatpoint');
  const textItems = document.querySelectorAll('.shoe-breakdown__text-item');
  const removeActiveClasses = () => {
    heatpoints.forEach(hp => hp.classList.remove('active'));
    textItems.forEach(item => item.classList.remove('active'));
  };

  const activateItem = (part) => {
    removeActiveClasses();
    const heatpoint = document.querySelector(`.shoe-breakdown__heatpoint[data-part='${part}']`);
    const textItem = document.querySelector(`.shoe-breakdown__text-item[data-part='${part}']`);

    if (heatpoint) heatpoint.classList.add('active');
    if (textItem) textItem.classList.add('active');
  };

  heatpoints.forEach(heatpoint => {
    heatpoint.addEventListener('click', (e) => {
      e.stopPropagation();
      const part = heatpoint.dataset.part;
      activateItem(part);
    });
  });

  textItems.forEach(item => {
    item.addEventListener('click', () => {
      const part = item.dataset.part;
      activateItem(part);
    });
  });
});
